var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40142 12.8097C9.42055 12.8341 9.445 12.8539 9.47291 12.8675C9.50082 12.8811 9.53146 12.8881 9.5625 12.8881C9.59354 12.8881 9.62418 12.8811 9.65209 12.8675C9.68 12.8539 9.70445 12.8341 9.72358 12.8097L12.5872 9.18665C12.692 9.05369 12.5974 8.85682 12.4261 8.85682H10.5315V0.204545C10.5315 0.0920454 10.4395 0 10.327 0H8.7929C8.6804 0 8.58835 0.0920454 8.58835 0.204545V8.85426H6.69886C6.52756 8.85426 6.43295 9.05114 6.53778 9.18409L9.40142 12.8097ZM18.9205 11.9148H17.3864C17.2739 11.9148 17.1818 12.0068 17.1818 12.1193V16.0568H1.94318V12.1193C1.94318 12.0068 1.85114 11.9148 1.73864 11.9148H0.204545C0.0920454 11.9148 0 12.0068 0 12.1193V17.1818C0 17.6344 0.365625 18 0.818182 18H18.3068C18.7594 18 19.125 17.6344 19.125 17.1818V12.1193C19.125 12.0068 19.033 11.9148 18.9205 11.9148Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.7c7028652f2d7ff8ee7267e60297a7ae.svg";
export { ForwardRef as ReactComponent };